import React, { FC } from 'react'
import clsx from 'clsx'
import { useActive, useCommands } from '@remirror/react'

import { Select } from 'antd'

import { ReactComponent as Bold } from '../../../assets/bold.svg'
import { ReactComponent as Underline } from '../../../assets/underline.svg'
import { ReactComponent as Italic } from '../../../assets/italic.svg'
import { ReactComponent as Paragraph } from '../../../assets/pilcrow.svg'
import { ReactComponent as H1 } from '../../../assets/h1.svg'
import { ReactComponent as H2 } from '../../../assets/h2.svg'
import { ReactComponent as H3 } from '../../../assets/h3.svg'
import { ReactComponent as HR } from '../../../assets/hr.svg'
import { ReactComponent as NumberList } from '../../../assets/numberList.svg'
import { ReactComponent as BulletList } from '../../../assets/bulletList.svg'
import { ReactComponent as Undo } from '../../../assets/undo.svg'
import { ReactComponent as Redo } from '../../../assets/redo.svg'

import styles from '../_.module.css'

const Line = () => (
  <div className={styles.line}>
    <span className={styles.lineItem} />
  </div>
)

const MinifiedMenu: FC = () => {
  const commands = useCommands()
  const active = useActive()
  const headingListOptions = [
    {
      value: 1,
      label: <H1 />
    },
    {
      value: 2,
      label: <H2 />
    },
    {
      value: 3,
      label: <H3 />
    },
    {
      value: 'hr',
      label: <HR />
    },
    {
      value: 'paragraph',
      label: <Paragraph />
    }
  ]

  const updateHeading = (val: string | number) => {
    if (!isNaN(Number(val))) {
      commands.toggleHeading({ level: Number(val) })
    } else if (val === 'paragraph') {
      commands.insertParagraph(' ')
    } else {
      commands.insertHorizontalRule()
    }
    commands.focus()
  }

  return (
    <div className={clsx(styles.menuArea, styles.customScrollBar)}>
      <div className={clsx(styles.menuWrap, styles.revertedMenu)}>
        <button
          type="button"
          onClick={() => {
            commands.toggleBold()
            commands.focus()
          }}
          className={clsx(styles.buttonWrap, {
            [styles.activeButton]: active.bold()
          })}
        >
          <Bold />
        </button>
        <button
          type="button"
          onClick={() => {
            commands.toggleItalic()
            commands.focus()
          }}
          className={clsx(styles.buttonWrap, {
            [styles.activeButton]: active.italic()
          })}
        >
          <Italic />
        </button>

        <button
          type="button"
          onClick={() => {
            commands.toggleUnderline()
            commands.focus()
          }}
          className={clsx(styles.buttonWrap, {
            [styles.activeButton]: active.underline()
          })}
        >
          <Underline />
        </button>
        <Select
          onChange={(e: any): void => updateHeading(e)}
          className={styles.selectWrap}
          options={headingListOptions}
          placeholder={<H1 />}
          size="small"
        />

        <Line />

        <button
          type="button"
          onClick={() => {
            commands.toggleOrderedList()
            commands.focus()
          }}
          className={clsx(styles.buttonWrap, {
            [styles.activeButton]: active.orderedList()
          })}
        >
          <NumberList />
        </button>
        <button
          type="button"
          onClick={() => {
            commands.toggleBulletList()
            commands.focus()
          }}
          className={clsx(styles.buttonWrap, {
            [styles.activeButton]: active.bulletList()
          })}
        >
          <BulletList />
        </button>

        <Line />

        <button
          type="button"
          onClick={() => {
            commands.undo()
            commands.focus()
          }}
          disabled={!commands.undo.enabled()}
          className={clsx(styles.buttonWrap, {
            [styles.disabledButton]: !commands.undo.enabled()
          })}
        >
          <Undo />
        </button>
        <button
          type="button"
          onClick={() => {
            commands.redo()
            commands.focus()
          }}
          disabled={!commands.redo.enabled()}
          className={clsx(styles.buttonWrap, {
            [styles.disabledButton]: !commands.redo.enabled()
          })}
        >
          <Redo />
        </button>
      </div>
    </div>
  )
}

export default MinifiedMenu
